import React from 'react';
import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-8a80a17d.esm.js';
import styled, { keyframes } from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var _templateObject, _templateObject2;
var shine = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n    background-position: -468px 0;\n  }\n  \n  100% {\n    background-position: 468px 0; \n  }\n"])));
var LinearShimmer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: ", ";\n\theight: ", ";\n\tborder-radius: ", ";\n\tmargin-left: ", ";\n\tmargin-right: ", ";\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tbackground: ", ";\n\tbackground-image: ", ";\n\tbackground-repeat: no-repeat;\n\tbackground-size: 800px 400px;\n\tdisplay: inline-block;\n\tposition: relative;\n\tanimation: ", " 1s linear infinite;\n\tflex-shrink: 0;\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.radius;
}, function (p) {
  return p.marginLeft;
}, function (p) {
  return p.marginRight;
}, function (p) {
  return p.marginTop;
}, function (p) {
  return p.marginBottom;
}, function (p) {
  return p.backgroundColor;
}, function (p) {
  return p.shimmerColor;
}, shine);

var HorizontalShimmer = function HorizontalShimmer(_ref) {
  var width = _ref.width,
      height = _ref.height,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginTop = _ref.marginTop,
      radius = _ref.radius,
      customStyle = _ref.customStyle,
      shimmerColor = _ref.shimmerColor,
      backgroundColor = _ref.backgroundColor,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(LinearShimmer, {
    width: width,
    height: height,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginTop: marginTop,
    radius: radius,
    style: _extends({}, customStyle),
    shimmerColor: shimmerColor,
    backgroundColor: backgroundColor
  }, children);
};

HorizontalShimmer.defaultProps = {
  width: '1rem',
  height: '1rem',
  marginLeft: 0,
  marginRight: 0,
  marginBottom: 0,
  marginTop: 0,
  radius: '0.2rem',
  customStyle: undefined,
  shimmerColor: 'linear-gradient(to right, #E1E7EE 0%, #E1E7EE 20%, #E1E7EE 40%, #E1E7EE 100%)',
  backgroundColor: '#f6f7f8',
  children: undefined
};

export { HorizontalShimmer };
